import React, { Component } from "react"
import { Formik, Field, Form } from "formik"
import moveSaleFields from "models/moveSale"
import fieldStatus from "helpers/fieldStatus"
import * as Yup from "yup"
import submitData from "helpers/submitData"
import Typeahead from "components/Typeahead"
import _ from "lodash"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import { bindActionCreators } from "redux"

class MoveSale extends Component {
	constructor(props) {
		super(props)
		this.state = {
			fields: moveSaleFields,
			data: {
				address: "",
			},
		}
	}

	componentDidMount() {
	}

	validation = () => {
		return Yup.object().shape({
			move_to_id: Yup.number().min(1, "Please choose an address from the list.").required("Required"),
		})
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	render() {
		return (
			<div className="modal">
				<h3>
					Move Sale: {this.props.data.address}
				</h3>
				<Formik
					initialValues={this.state.fields}
					validationSchema={this.validation}
					validateOnMount={true}
					enableReinitialize
					onSubmit={(values) => {
						values.sale_id = this.props.data.sale_id
						values.lot_id = this.props.data.id
						//return
						submitData("inputMoveSale", values)
							.then((data) => {
								this.props.notify(data, this.props.name)
							})
							.catch((e) => {
								this.props.notify(e, this.props.name)
							})
					}}
					render={(f) => (
						<div>
							{/* console.log(f) */}
							<Form>
								<ul className="modalForm__list">
									<li className={fieldStatus("move_to_id", f)}>
										<label htmlFor="move_to_id">Destination Address</label>
										{f.errors.move_to_id && f.touched.move_to_id && (
											<div className="form__message">{f.errors.move_to_id}</div>
										)}
										<Typeahead
											name="move_to_id"
											className="form__input"
											value={f.values.move_to_id.value}
											onChange={(name, val) => {
												f.setFieldValue(name, val)
											}}
											onBlur={f.setFieldTouched}
											touched={f.touched.move_to_id}
											error={f.errors.move_to_id}
											placeholder={f.values.label_address}
											ep="/addressesAvailableToSell"
											extra={this.props.data}
											super={this.props.super}
										/>
									</li>
								</ul>
								<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
							</Form>
						</div>
					)}
				/>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		trafficSources: state.trafficSources,
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(MoveSale)
